/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AddBoxOutlined, ManageSearch} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_IMG,
    CASILLA_PARRAFO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import {ESTADOANUNCIOS} from "../../Constantes";
import Dialogo_Testimonios from "../Dialogos/Dialogo_Testimonios";


const Seccion_Testimonios = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'testimonios'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Testimonios,
        titulo: 'Detalles del testimonio',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break

        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Testimonios'}
                        descripcion={`${numeroFilas} testimonios en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Testimonios

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: 'testimonio',
        direccion: 'left',
        propiedad: 'testimonio',
        lineas: 2,
        tipo: CASILLA_PARRAFO
    },

    {
        nombre: 'Link',
        direccion: 'left',
        propiedad: 'link',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOANUNCIOS
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]


